module.exports = __webpack_public_path__ + "static/img/4.7b571d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/sjg/4.jpg
// module id = uF5m
// module chunks = 1